var render, staticRenderFns
import script from "./BaseChip.vue?vue&type=script&lang=ts&"
export * from "./BaseChip.vue?vue&type=script&lang=ts&"
import style0 from "./BaseChip.vue?vue&type=style&index=0&id=577f3e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577f3e7e",
  null
  
)

export default component.exports